import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import store from '../store'
import {
  getToken
} from '@/utils/auth'

let baseURL;
if (process.env.NODE_ENV === 'production') {
  baseURL = process.env.BASE_API
}else{
  baseURL = "/api"
  // baseURL = process.env.BASE_API
}
// 创建axios实例
const service = axios.create({
  baseURL: baseURL,
  timeout: 150000
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    if (process.env.NODE_ENV === 'development') {
      config.headers['user'] = "{'id':3}"
    }
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    if (res.code !== 200) {
      // 新生成接口的业务失败仍携带状态与错误码，由调用方展示并决定是否重试。
      if (response.config && response.config.preserveBusinessResult && res.code === 500 && res.data) {
        return res
      }
      if (res.type) {
        return res
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
        // 401:未登录;
        if (res.code === 401) {
          MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('FedLogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
        }
        return Promise.reject('error')
      }
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    const responseData = error.response && error.response.data
    const errorMessage = responseData && (responseData.error_description || responseData.message)
    Message({
      message: errorMessage || error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js